export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjcxMTdiN2RmLTk5ZGMtNGVlMy1iMzU3LWQyYjZiNmM2ZjU3YiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.bPW4mqJcmeyJxupNsXTnOO3/NKRTZPcmd8JKkkDoiyyt5KdawhEKxY/BZZKJypAXZCD6QN9wsCv4eLKoV1wBS8j47daEWOkF2/hW+2l4YRH3OyO2lb0Hq9qKF1FYqXXvKmXmiA==';
